interface createPatternCanvasParams {
    img: HTMLImageElement | HTMLVideoElement
    width: number
    height: number
    ctx: CanvasRenderingContext2D
}

export const createPatternCanvas = ({
    img,
    width,
    height,
    ctx,
}: createPatternCanvasParams): CanvasPattern | null => {
    if (width <= 0 || height <= 0) {
        return null
    }

    const patternCanvas = document.createElement("canvas")
    const patternCtx = patternCanvas.getContext("2d")

    if (!patternCtx) return null

    patternCtx.imageSmoothingEnabled = true
    patternCtx.imageSmoothingQuality = "high"

    patternCanvas.width = Math.max(1, width)
    patternCanvas.height = Math.max(1, height)
    patternCtx.drawImage(img, 0, 0, width, height)

    return ctx.createPattern(patternCanvas, "repeat")
}

export const createTransformMatrix = (position: {
    x: number
    y: number
}): DOMMatrix => {
    return new DOMMatrix().translate(position.x, position.y)
}
